import React, { useState, useEffect } from "react";
import { TextField, Button, Box, Typography } from "@mui/material";

const PostalCodePrompt = ({ setPostalCode }) => {
  const [postalCode, setLocalPostalCode] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    // Check local storage for postal code
    const storedPostalCode = localStorage.getItem("postalCode");
    if (storedPostalCode) {
      setPostalCode(storedPostalCode); // Pass it to parent
    }
  }, [setPostalCode]);

  const validatePostalCode = (code) => {
    const canadaRegex = /^[A-Za-z]\d[A-Za-z][ -]?\d[A-Za-z]\d$/;
    const usRegex = /^\d{5}(-\d{4})?$/;
    return canadaRegex.test(code) || usRegex.test(code);
  };

  const handleSubmit = () => {
    if (validatePostalCode(postalCode)) {
      setError("");
      localStorage.setItem("postalCode", postalCode);
      setPostalCode(postalCode); // Pass valid postal code to parent
    } else {
      setError("Please enter a valid postal code for Canada or the USA.");
    }
  };

  return (
    <Box sx={{ textAlign: "center", mt: 4 }}>
      <Typography variant="h6" gutterBottom>
        Enter Your Postal Code
      </Typography>
      <TextField
        label="Postal Code"
        variant="outlined"
        value={postalCode}
        onChange={(e) => setLocalPostalCode(e.target.value)}
        error={!!error}
        helperText={error}
        sx={{ mb: 2, width: "300px" }}
      />
      <Box>
        <Button variant="contained" onClick={handleSubmit}>
          Submit
        </Button>
      </Box>
    </Box>
  );
};

export default PostalCodePrompt;
